import React from 'react';

export default () => {
  return (
    <div>
      <>
        <p className="handler-title">Listar Grupos Cadastrados</p>
      </>

      <div className="common-form-group">
        <label>Acesse a variável para vizualizar a lista de Grupos</label>
        <input
          className="form-control mt-1"
          defaultValue="{glpi.group_list}"
          disabled
        />
      </div>
    </div>
  );
};
